module.exports = __webpack_public_path__ + "img/t2-open-content.f2eb513d.png";